import { useDataset } from "@/hooks/map/useDataset";
import { Dataset } from "@/types/dataset";

import SliderInput from "./SliderInput";

type OpacitySliderProps = {
  data: Dataset;
  isSpatialAnalysis?: boolean;
  isLabel?: boolean;
};

export default function OpacitySlider(props: Readonly<OpacitySliderProps>) {
  const { data, isLabel = false } = props;
  const { handleChangeOpacityDataset, handleChangeLabelOpacity } = useDataset();

  const handleChangeOpacity = (value: number) => {
    if (value > 100) value = 100;
    if (value < 0) value = 0;
    if (isLabel) {
      handleChangeLabelOpacity(data, Math.round(value) / 100);
      return;
    }
    handleChangeOpacityDataset(data.data.id, Math.round(value) / 100);
  };

  const handleChangeOpacitySlider = (value: number[]) => {
    if (isLabel) {
      handleChangeLabelOpacity(data, value[0] / 100);
      return;
    }

    handleChangeOpacityDataset(data.data.id, value[0] / 100);
  };

  const opacityValue = isLabel
    ? [(data?.style?.labelConfig?.opacity || 0) * 100]
    : [data.style.fillOpacity * 100];

  const opacityInputValue = isLabel
    ? Math.round((data.style?.labelConfig?.opacity || 0) * 100)
    : Math.round(data.style.fillOpacity * 100);

  return (
    <div className="flex flex-col gap-2 w-full">
      <p className="text-xs text-txtPlaceholder">Opacity</p>
      <SliderInput
        valueSlider={opacityValue}
        onChangeSlider={handleChangeOpacitySlider}
        valueInput={opacityInputValue}
        onChangeInput={handleChangeOpacity}
      />
    </div>
  );
}
